import { Inject, Injectable } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { JsonViewerDialogComponent } from './json-viewer.dialog';


@Injectable({
  providedIn: 'root'
})
export class JsonViewerDialogService {

    constructor(public dialog: MatDialog) {}

    public open(data: any) {
        this.dialog.open(JsonViewerDialogComponent, {
            width: '800px',
            data: data
        });
    }
}
